export default "__VITE_ASSET__8f1b1d51__"